import memoizeOne from 'memoize-one';
import Atc from '~/Api/Analytics/Atc';

import ActualPack from './ActualPack';
import RouteOfAdministration from './RouteOfAdministration';
import TherapeuticArea from './TherapeuticArea';
import VirtualPack from './VirtualPack';

export default class VirtualBrand {
	id: string;

	brandName: string;

	orphan: boolean;

	generic: boolean;

	biosimilar: boolean;

	originator: boolean;

	therapeuticAreas: TherapeuticArea[];

	routesOfAdministration: RouteOfAdministration[];

	atcs: Atc[];

	virtualPacks: VirtualPack[];

	constructor(
		id: string,
		brandName: string,
		orphan: boolean,
		generic: boolean,
		biosimilar: boolean,
		originator: boolean,
		therapeuticAreas: TherapeuticArea[],
		routesOfAdministration: RouteOfAdministration[],
		atcs: Atc[],
		virtualPacks: VirtualPack[]
	) {
		this.id = id;
		this.brandName = brandName;
		this.orphan = orphan;
		this.generic = generic;
		this.biosimilar = biosimilar;
		this.originator = originator;
		this.therapeuticAreas = therapeuticAreas;
		this.routesOfAdministration = routesOfAdministration;
		this.atcs = atcs;
		this.virtualPacks = virtualPacks;
	}

	get sortedVirtualPacks(): VirtualPack[] {
		return this.sortVirtualPacks(this.virtualPacks);
	}

	sortVirtualPacks = memoizeOne((virtualPacks) => {
		const sortedVirtualPacks = [...virtualPacks];
		sortedVirtualPacks.sort((pack, otherPack) => pack.distinctName.localeCompare(otherPack.distinctName));
		return sortedVirtualPacks;
	});

	get allActualPacks(): ActualPack[] {
		return this.virtualPacks.reduce<ActualPack[]>((result, virtualPack) => {
			result.push(...virtualPack.actualPacks);
			return result;
		}, []);
	}

	get mostAvailablePack(): VirtualPack | null {
		const virtualPacks = [...this.virtualPacks];
		virtualPacks.sort((a, b) => b.pricedActualPacks.length - a.pricedActualPacks.length);
		return virtualPacks[0] ?? null;
	}
}
